<template>
  <div class="login-container">
    <form @submit.prevent="handleLogin">
      <Alert type="danger" :messages="errors" />
      <div class="form-group custom-form-group">
        <label for="email">メールアドレス</label>
        <input
          type="email"
          v-model="username"
          class="form-control"
          name="email"
          v-validate="'required|email'"
          data-vv-as="メールアドレス"
          id="email"
        />
        <FieldError :message="formErrors.first('email')" />
      </div>
      <div class="form-group custom-form-group">
        <label for="password">パスワード</label>
        <div class="input-wrapper position-relative">
          <input
            :type="passwordType"
            id="password"
            v-model="password"
            class="form-control"
            data-vv-delay="0"
            v-validate="'required'"
            data-vv-as="パスワード"
            name="password"
          />
          <button
            class="btn-eye"
            type="button"
            @click="showPassword = !showPassword"
          >
            <i class="fa" :class="passwordEyeIcon" aria-hidden="true"></i>
          </button>
        </div>
        <FieldError :message="formErrors.first('password')" />
      </div>
      <div class="forgot-password mb-4">
        <router-link to="/forgot" class="forgot-link">
          パスワードをお忘れの場合
        </router-link>
      </div>
      <button
        class="submit-button"
        type="submit"
        :disabled="!validForm || processing"
      >
        ログイン
      </button>
    </form>
    <div class="terms mt-2">
      <router-link to="/agreement" class="forgot-link">
        法人向け利用規約
      </router-link>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/utils/Alert.vue';
import FieldError from '@/components/utils/FieldError.vue';
import actions from '@/config/actions';
import AuthService from '@/service/auth/authService';
import { mapActions } from 'vuex';

export default {
  name: 'LoginForm',
  components: { FieldError, Alert },
  data() {
    return {
      username: '',
      password: '',
      processing: false,
      errors: [],
      showPassword: false,
    };
  },
  mounted() {
    const emailInput = document.getElementById('email');
    if (emailInput) emailInput.focus();
  },
  computed: {
    payload() {
      return {
        username: this.username,
        password: this.password,
      };
    },
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
    passwordEyeIcon() {
      return this.showPassword ? 'fa-eye' : 'fa-eye-slash';
    },
    validForm() {
      const email = this.Vfields && this.Vfields.email;
      const password = this.Vfields && this.Vfields.password;
      if (email && password) {
        return (
          email.changed && password.changed && this.formErrors.count() === 0
        );
      }
      return false;
    },
  },
  methods: {
    ...mapActions([actions.auth.LOGIN, actions.auth.LOGGED_IN, 'loadCurrentUser']),
    handleLogin(event) {
      event.preventDefault();
      this.processing = true;
      this.errors = [];

      const self = this;
      this[actions.auth.LOGIN](this.payload)
        .then(function (response) {
          const data = response.data;
          const body = data && data.data;

          if (body && body.twofa_required) {
            const msg =
              data.message ||
              '確認メールを送信しました。受信トレイをご確認ください。';
            self.errors = [];
            self.$router.push({
              path: '/twofa-sent',
              query: { message: msg },
            });
            return;
          }

          const authCode = body && body.authorization_code;
          if (authCode) {
            return AuthService.exchangeToken(authCode).then(
              function (tokenResponse) {
                const tokenData = tokenResponse.data && tokenResponse.data.data;
                const expiresIn = tokenData && tokenData.expires_in;
                self.errors = [];
                self[actions.auth.LOGGED_IN]({ expires_in: expiresIn });
                self.$router.push('/applicant');
                // return self.loadCurrentUser().then(function (user) {
                //   if (user && user.isAdmin) {
                //     self.$router.push('/pending-applicants');
                //   } else {
                //     self.$router.push('/applicant');
                //   }
                // });
              }
            );
          }

          self.errors = ['ログインに失敗しました。'];
        })
        .catch(function (error) {
          const response = error.response;
          self.errors = [];

          if (response && response.status === 422) {
            const errs = response.data && response.data.errors;
            const fieldErrors = AuthService.mapValidationErrors(errs);
            const keys = Object.keys(fieldErrors);
            if (keys.length) {
              for (let i = 0; i < keys.length; i++) {
                if (fieldErrors[keys[i]]) {
                  self.errors.push(fieldErrors[keys[i]]);
                }
              }
            } else {
              var msg422 = (response.data && response.data.message) ||
                (response.data && response.data.error_description);
              self.errors.push(msg422 || 'Validation failed.');
            }
            return;
          }

          if (response && response.status === 401) {
            const msg401 =
              response.data === 'Unauthorized'
                ? response.data
                : response.data && response.data.message
                ? response.data.message
                : response.data &&
                  response.data.data &&
                  response.data.data.message
                ? response.data.data.message
                : response.data && response.data.error_description
                ? response.data.error_description
                : 'IDまたはパスワードが間違っています。';
            return self.errors.push(msg401);
          }
          if (response && response.status === 402) {
            const msg402 =
              response.data && response.data.message ||
              'アカウントがブロックされています。管理者にお問い合わせ下さい。';
            return self.errors.push(msg402);
          }
          if (response && response.status === 403) {
            return self.errors.push('IDまたはパスワードが間違っています。');
          }
          if (response && response.status === 400) {
            const msg400 =
              response.data && response.data.message ||
              (response.data && response.data.error_description) ||
              'Invalid request.';
            return self.errors.push(msg400);
          }
          if (response && response.status === 503) {
            const msg503 =
              (response.data && response.data.message) ||
              (response.data && response.data.error_description) ||
              'Service unavailable.';
            return self.errors.push(msg503);
          }

          self.parseErrorResponse(response);
        })
        .then(
          function () {},
          function () {}
        )
        .finally(function () {
          self.processing = false;
        });
    },
  },
};
</script>
<style scoped>
.login-container {
  max-width: 500px;
  width: 100%;
  /* text-align: center; */
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: #617776;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ced4da;
  border-radius: 4px;
  margin-bottom: 10px;
  background: #f8f9fa !important;
}

.submit-button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  background-color: #036d6c;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: auto;
}

.terms {
  float: right;
  font-weight: bold;
  color: red;
}

.position-relative {
  position: relative;
}

.btn-eye {
  top: 5%;
  right: 10px;
}

.custom-form-block .form-control.is-invalid {
  background: none;
}
.custom-form-block .form-control.is-valid {
  background: none;
}
</style>
